<template>
  <div>
    <v-layout
      row
      justify-center
    >
      <v-dialog
        v-model="addEditExpenseModal"
        persistent
        max-width="700px"
      >
        <v-card>
          <form @submit.prevent="submitForm()">
            <v-card-title class="pb-0">
              <v-flex
                xs11
                sm10
                md10
              ><span class="headline">
                  {{ isUpdate ? $t('finance.updateExpenseTitle') : $t('finance.addExpenseTitle') }}
                </span></v-flex>
              <v-flex
                xs1
                sm2
                md2
              >
                <v-btn
                  flat
                  @click="closeDialog()"
                  class="close"
                >
                  <span aria-hidden="true">
              <i class="material-icons" style="font-size: 24px;vertical-align: middle;">close</i>
            </span></v-btn>
              </v-flex>
            </v-card-title>
            <v-card-text>
              <v-alert
                type="success"
                :value="isDone"
              >
                {{ isUpdate ? $t('common.updatedSuccessfully') : $t('common.addedSuccessfully') }}
              </v-alert>

              <v-alert
                type="error"
                :value="errorAlert"
              >
                {{ $t('finance.thereIsAnError') }}
              </v-alert>
              <v-layout wrap>

                <!-- <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                  lg6
                >
                  <branch-select v-model="formData.branch_id_fk" />
                </v-flex> -->

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                  lg6
                >
                  <v-select
                    autocomplete
                    :items="expenseTypesList"
                    v-model="formData.expense_type_id_fk"
                    :error-messages="errors.collect('Expense Type')"
                    data-vv-name="Expense Type"
                    :label="$t('columns.expenseType') + ' *'"
                    v-validate="'required'"
                  >
                  </v-select>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                  lg6
                >
                  <v-select
                    autocomplete
                    :items="suppliersList"
                    v-model="formData.supplier_id_fk"
                    :error-messages="errors.collect('Supplier')"
                    data-vv-name="Supplier"
                    :label="$t('columns.supplier') + ' *'"
                    v-validate="'required'"
                  >
                  </v-select>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                  lg6
                >
                  <v-select
                    autocomplete
                    :items="banksList"
                    v-model="formData.bank_id_fk"
                    :error-messages="errors.collect('Bank')"
                    data-vv-name="Bank"
                    :label="$t('columns.bank') + ' *'"
                    v-validate="'required'"
                  >
                  </v-select>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                  lg6
                >
                  <v-text-field
                    :label="$t('finance.supplierInvoiceNumberLabel')"
                    v-model="formData.supplier_invoice_number"
                    :error-messages="errors.collect('Supplier Invoice Number')"
                    data-vv-name="Supplier Invoice Number"
                  />
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                  lg6
                >
                  <v-text-field
                    :label="$t('columns.amount') + ' *'"
                    v-model="formData.amount"
                    :error-messages="errors.collect('Amount')"
                    v-validate="'required'"
                    data-vv-name="Amount"
                  />
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                  lg6
                >
                  <v-select
                    autocomplete
                    :items="expenseStatusList"
                    v-model="formData.status"
                    :error-messages="errors.collect('Status')"
                    data-vv-name="Status"
                    :label="$t('columns.status') + ' *'"
                    v-validate="'required'"
                  >
                  </v-select>
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                  lg6
                >
                  <label class="d-block mb-1">{{ $t('columns.expenseDate') }}</label>
                  <input
                    type="date"
                    v-model="formData.expense_date"
                    class="base-date-picker"
                  >
                </v-flex>

                <v-flex
                  class="px-2"
                  xs12
                  sm6
                  md6
                  lg6
                >
                  <v-text-field
                    :label="$t('columns.note')"
                    v-model="formData.note"
                    :error-messages="errors.collect('Note')"
                    data-vv-name="Note"
                  />
                </v-flex>
              </v-layout>
            </v-card-text>
            <v-card-actions>
              <v-spacer></v-spacer>
              <v-btn
                style="height:auto"
                @click="closeDialog()"
                outline
                color="normal"
              >{{ $t('common.cancel') }}</v-btn>
              <v-btn
                type="submit"
                :loading="loading"
                style="height:auto" class="submit-btn-spacing"
                outline
                color="success"
              >
                {{ isUpdate ? $t('common.save') : $t('common.add') }}
              </v-btn>
            </v-card-actions>
          </form>
        </v-card>
      </v-dialog>
    </v-layout>
  </div>
</template>
<script>
import Axios from 'axios'

export default {
  props: [
    'addEditExpenseModal',
    'formData',
    'isUpdate',
    'expenseTypesList',
    'suppliersList',
    'banksList',
  ],

  data() {
    return {
      loading: false,
      isDone: false,
      errorAlert: false,
      expenseStatusList: [
        { text: this.$t('finance.statusPaid'), value: 'paid' },
        { text: this.$t('finance.statusUnpaid'), value: 'unpaid' },
        { text: this.$t('common.cash'), value: 'cash' }
      ]
    }
  },

  methods: {
    closeDialog() {
      this.$validator.reset()
      this.$emit('close')
    },

    submitForm() {
      let token = localStorage.getItem('access_token')

      this.$validator.validateAll().then((res) => {
        if (res) {
          if (this.isUpdate) {
            Axios.put(`api/expenses/${this.formData.expense_id}`, this.formData, {
              headers: { Authorization: 'Bearer ' + token },
            })
              .then(() => {
                this.errorAlert = false
                this.isDone = true
                setTimeout(() => {
                  this.isDone = false
                  this.$emit('resetTable')
                  this.closeDialog()
                }, 2000)
              })
              .catch(() => {
                this.isDone = false
                this.errorAlert = true
                setTimeout(() => {
                  this.errorAlert = false
                }, 1500)
              })
          } else {
            Axios.post('api/expenses', this.formData, {
              headers: { Authorization: 'Bearer ' + token },
            })
              .then(() => {
                this.errorAlert = false
                this.isDone = true
                setTimeout(() => {
                  this.isDone = false
                  this.$emit('resetTable')
                  this.closeDialog()
                }, 2000)
              })
              .catch(() => {
                this.isDone = false
                this.errorAlert = true
                setTimeout(() => {
                  this.errorAlert = false
                }, 1500)
              })
          }
        }
      })
    },
  },
}
</script>

<style>
.overlay--active:before {
  opacity: 50 !important;
  background: rgba(0, 0, 0, 0.5) !important;
}

.dialog {
  box-shadow: 0 3px 5px -1px rgba(14, 14, 14, 0.212) !important;
  overflow: hidden !important;
  overflow-y: auto !important;
}
</style>



// WEBPACK FOOTER //
// src/components/expense/addEdit.vue